import React from 'react';

import { PayOutlet } from 'components';
import { ROUTE_PATH } from 'constants/routes';

export const OperatorOrdersPage: React.FC = () => (
  <PayOutlet
    payinTo={ROUTE_PATH.OPERATOR.PAYIN_ORDERS}
    payoutTo={ROUTE_PATH.OPERATOR.PAYOUT_ORDERS}
  />
);
